document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".personalised-label").forEach(function(wrapper){

    const checkbox = wrapper.querySelector(".js-gift-toggle");
    const fields = wrapper.querySelector(".personalised-label__fields");

    const nameInput = wrapper.querySelector(".js-gift-name");
    const messageInput = wrapper.querySelector(".js-gift-message");

    const previewName = wrapper.querySelector(".js-preview-name");
    const previewMessage = wrapper.querySelector(".js-preview-message");

    if (!checkbox || !fields) return;

    checkbox.addEventListener("change", function () {
      fields.style.display = checkbox.checked ? "block" : "none";
    });

    function updatePreview() {
      previewName.textContent = nameInput.value || "";
      previewMessage.textContent = messageInput.value || "";
    }

    nameInput.addEventListener("input", updatePreview);
    messageInput.addEventListener("input", updatePreview);

    updatePreview();

  });

}); // <-- THIS WAS MISSING

document.addEventListener('product:added', function (event) {
  console.log('Personalised Label: product added', event.detail);
});